import moment from 'moment-timezone'
import React from 'react'

import Spinner from 'components/Spinner'

import useCurrentDeviceState from 'hooks/useCurrentDeviceState'

import { NoData } from 'styles/shared'
import styled from 'styled-components'
import useDeviceDetails from 'hooks/useDeviceDetails'

type Props = {
  deviceId: string
  timeZone: string
}

const CurrentDeviceState = ({ deviceId, timeZone }: Props) => {
  const { currentDeviceState, isCurrentDeviceStateLoaded } = useCurrentDeviceState(deviceId)
  const { deviceMetadataDetails, areDeviceDetailsLoaded } = useDeviceDetails(deviceId)

  if (!isCurrentDeviceStateLoaded) {
    return (<Spinner variant="page" />)
  }

  let deviceTimeZone = timeZone
  if (areDeviceDetailsLoaded) {
    deviceTimeZone ||= String(deviceMetadataDetails?.find((item) => item.column === 'time_zone_name')?.value || '')
  }

  return (
    <div>
      {currentDeviceState
        ? (
          <>
            <S.LastUpdatedAt>{`Last Updated At: ${moment(currentDeviceState['last_updated_at']).tz(deviceTimeZone).format()}`}</S.LastUpdatedAt>
            <pre>{JSON.stringify(currentDeviceState, null, 2)}</pre>
          </>
        )
        : <NoData><h1>Not Available</h1></NoData> }
    </div>
  )
}

export default CurrentDeviceState

const S = {
  NoData: styled(NoData)`
    h1 {
      font-size: 24px;
    }
  `,
  LastUpdatedAt: styled.h3`
    margin-top: 10px;
    margin-bottom: 10px;
  `
}
